











































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {MotoristaCancelamentoCarga} from '@/model/resource/MotoristaCancelamentoCarga'
import {MotoristaCancelamentoCargaCollection} from '@/model/collection/MotoristaCancelamentoCargaCollection'
import {ListMotoristaCancelamentoCargaSchema} from '@/schema/resource/MotoristaCancelamentoCarga/ListMotoristaCancelamentoCargaSchema'
import {CsvMotoristaCancelamentoCargaSchema} from '@/schema/resource/MotoristaCancelamentoCarga/CsvMotoristaCancelamentoCargaSchema'

@Component
export default class ListMotoristaCancelamentoCargaView extends Mixins(
  MixinQueryRouter
) {
  schema = new ListMotoristaCancelamentoCargaSchema()
  collection = new MotoristaCancelamentoCargaCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: MotoristaCancelamentoCarga) {
    Helper.pushByName('editMotoristaCancelamentoCarga', item.$id)
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new MotoristaCancelamentoCargaCollection()
      .clearFilters()
      .addFilter(params)

    await csv.listCsvMotoristaCancelamentoCarga()
    new CsvMotoristaCancelamentoCargaSchema().downloadCsv(csv.all())
  }
}
